import { Button } from "@mui/material";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import AvailableTeams from "./AvailableTeams";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { League } from "../WeekAtAGlance/IndividualTournament";
import { useCallback, useEffect, useState } from "react";

interface NewTeamBuilder {
  [key: string]: TeamList;
}

export interface TeamList {
  [key: string]: TeamDetails;
}

export interface TeamDetails {
  teamName: string;
  teamHandicap: number;
  positions: TeamDetailsPositions;
}
export interface TeamDetailsPositions {
  [key: number]: TeamPositionPlayers;
}
export interface TeamPositionPlayers {
  players: TeamPositionPlayer[];
  isSplitSpot: boolean;
  isTeamCaptain: boolean;
}

export interface TeamPositionPlayer {
  playerId: string;
  isVisitingPlayer: boolean;
  PlayerName: string;
  PlayerRating: number;
}

function LeagueSignUp({
  devPort,
  league,
  managerMode,
  clubId,
}: {
  devPort: string;
  league: League;
  managerMode: number;
  clubId: number;
}) {
  const navigate = useNavigate();
  const [tournamentTeams, setTournamentTeams] = useState<NewTeamBuilder>({
    pending: {},
    approved: {},
    declined: {},
  });
  const loadTeamList = useCallback(() => {
    const fetchTeams =
      devPort + "tournament_team_list/" + clubId + "/" + league.tournament_id;
    fetch(fetchTeams)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          let newTeams: NewTeamBuilder = {
            pending: {},
            approved: {},
            declined: {},
          };
          let newTeamBelongingToPlayer: number[] = [];
          data.forEach((player: any[]) => {
            let teamStatus = "pending";
            if (player[12] === 1) {
              teamStatus = "approved";
            } else if (player[12] === 2) {
              teamStatus = "declined";
            }
            if (managerMode !== -1 && managerMode === player[2]) {
              newTeamBelongingToPlayer.push(player[0]);
            }
            //If the team is not in the newTeams object, add it
            if (!(player[0] in newTeams[teamStatus])) {
              newTeams[teamStatus][player[0]] = {
                teamName: player[1],
                teamHandicap: 0,
                positions: {},
              };
            }
            //If the position is not in the team, add them
            if (!(player[8] in newTeams[teamStatus][player[0]].positions)) {
              newTeams[teamStatus][player[0]].positions[player[8]] = {
                players: [],
                isSplitSpot: player[6],
                isTeamCaptain: false,
              };
            }
            //Add the player to the team
            newTeams[teamStatus][player[0]].positions[player[8]].players.push({
              playerId: player[2],
              isVisitingPlayer: player[7],
              PlayerName: player[3] + " " + player[4],
              PlayerRating: player[5],
            });
          });
          //Calculate the team handicap
          Object.keys(newTeams).forEach((teamStatus) => {
            Object.keys(newTeams[teamStatus]).forEach((teamId) => {
              const team = newTeams[teamStatus][teamId];
              let totalRating = 0;
              Object.keys(team.positions).forEach((position) => {
                // Get the maximum rating among players at this position
                const maxPositionRating = Math.max(
                  ...team.positions[Number(position)].players.map(
                    (player: TeamPositionPlayer) => player.PlayerRating
                  )
                );
                totalRating += maxPositionRating;
              });
              newTeams[teamStatus][teamId].teamHandicap = totalRating;
            });
          });
          if (managerMode !== -1) {
            // Convert the object to an array of entries, filter, and convert back to object
            console.log(newTeamBelongingToPlayer);
            console.log(newTeams.pending);
            const filteredPendingTeams = Object.fromEntries(
              Object.entries(newTeams.pending).filter(([teamId]) => {
                return newTeamBelongingToPlayer.includes(Number(teamId));
              })
            );
            newTeams.pending = filteredPendingTeams;
            console.log(filteredPendingTeams);
          }
          console.log(newTeams);
          setTournamentTeams(newTeams);
        }
      });
  }, [devPort, clubId, league.tournament_id, managerMode]);

  useEffect(() => {
    loadTeamList();
  }, [loadTeamList]);

  return (
    <Accordion key={league.tournament_id} defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
      >
        <Typography variant="h5">League {league.league_name}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AvailableTeams
          title="Pending Teams"
          teams={tournamentTeams.pending}
          areTeamsPending={true}
          tournamentId={league.tournament_id}
          devPort={devPort}
          reloadTeams={loadTeamList}
          managerMode={managerMode}
          clubId={clubId}
          league={league}
        />
        <AvailableTeams
          title="Approved Teams"
          teams={tournamentTeams.approved}
          areTeamsPending={false}
          tournamentId={league.tournament_id}
          devPort={devPort}
          reloadTeams={loadTeamList}
          managerMode={managerMode}
          clubId={clubId}
          league={league}
        />
        {managerMode === -1 && (
          <AvailableTeams
            title="Declined Teams"
            teams={tournamentTeams.declined}
            areTeamsPending={false}
            tournamentId={league.tournament_id}
            devPort={devPort}
            reloadTeams={loadTeamList}
            managerMode={managerMode}
            clubId={clubId}
            league={league}
          />
        )}
        <Button
          variant="contained"
          color="success"
          style={{ width: "100%" }}
          onClick={() => {
            navigate("/addtournamentteam");
          }}
        >
          Register New Team
        </Button>
      </AccordionDetails>
    </Accordion>
  );
}

export default LeagueSignUp;
